import React, { useMemo, useState, useEffect } from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import { IS_DESKTOP_SCALE,IS_HORIZONTAL } from "../../../AtomStates";
import gyeongwonLogo from "../../../../assets/images/gyunwonlogo.png";

const Line687 = ({ isToday = false }) => {
  return <StyledLine isToday={isToday} />;
};

const MoleculeMenuBoardInfoBoard = ({
  menuData,
  clockEnabled = true,
  logo,
  showWeeklyView = false, // showWeeklyView prop이 true면 주간 식단, false면 일일 식단을 보여줌.
  orientation // Added orientation prop
}) => {
  const [isDesktopScale] = useAtom(IS_DESKTOP_SCALE);
  const [atomIsHorizontal] = useAtom(IS_HORIZONTAL);
  
  // Use orientation prop if available, otherwise fallback to atom
  const isHorizontal = orientation ? orientation === 'landscape' : atomIsHorizontal;


    const dummyMenuData = {
        "meal_schedule": [ // YYYY-MM-DD 형식으로 날짜 수정
            {
                "date": "2025-12-01",
                "lunch_menu": [
                    "백미밥",
                    "시락국",
                    "헐랭이수육",
                    "온두부/양념장",
                    "상추쌈/쌈장",
                    "배추김치"
                ],
                "lunch_origins": "돼지고기: 미국산",
                "dinner_menu": [
                    "백미밥",
                    "김치햄짜글이",
                    "고추잡채&꽃빵",
                    "콘샐러드",
                    "오징어젓갈무침",
                    "배추김치"
                ],
                "dinner_origins": "돼지고기: 미국산"
            },
            {
                "date": "2025-12-02",
                "lunch_menu": [
                    "백미밥",
                    "소고기미역국",
                    "소고기숙주볶음",
                    "라따뚜이",
                    "브로컬리버섯숙회",
                    "배추김치"
                ],
                "lunch_origins": "소고기: 호주산",
                "dinner_menu": [
                    "백미밥",
                    "크림스프",
                    "함박스테이크",
                    "미트볼크림파스타",
                    "피클&할리피뇨",
                    "배추김치"
                ],
                "dinner_origins": "소고기, 돼지고기: 국내산"
            },
            {
                "date": "2025-12-03",
                "lunch_menu": [
                    "백미밥",
                    "닭개장",
                    "순대콩나물찜",
                    "연근땅콩조림",
                    "도토리묵/양념장",
                    "배추김치"
                ],
                "lunch_origins": "닭고기: 국내산",
                "dinner_menu": [],
                "dinner_origins": ""
            },
            {
                "date": "2025-12-04",
                "lunch_menu": [
                    "백미밥",
                    "팽이버섯된장국",
                    "마파두부",
                    "비엔나감자볶음",
                    "방아고추전",
                    "배추김치"
                ],
                "lunch_origins": "돼지고기: 미국산",
                "dinner_menu": [
                    "백미밥",
                    "순두부찌개",
                    "탕수육/소스",
                    "감자채전",
                    "고추된장무침",
                    "배추김치"
                ],
                "dinner_origins": "돼지고기: 미국산"
            },
            {
                "date": "2025-12-05",
                "lunch_menu": [
                    "콩나물버섯밥",
                    "얼큰어묵탕",
                    "너비아니파채구이",
                    "사누끼우동볶음",
                    "요구르트",
                    "배추김치"
                ],
                "lunch_origins": "돼지고기: 미국산",
                "dinner_menu": [],
                "dinner_origins": ""
            }
        ]
    

  };
  
  
  // menuData가 없으면 더미 데이터 사용
  const finalMenuData = menuData || dummyMenuData;
    

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const mondayOfWeek = new Date(today);
  const day = mondayOfWeek.getDay();
  const diff = mondayOfWeek.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
  mondayOfWeek.setDate(diff);

  // 메뉴 데이터 처리 (meal_schedule 사용)
  const mealSchedule = useMemo(() => {
    const schedule = finalMenuData?.meal_schedule || [];

    // 이번 주 월~금 날짜 계산
    const currentMonday = new Date(mondayOfWeek);
    const weekDates = [];
    for (let i = 0; i < 5; i++) {
      const d = new Date(currentMonday);
      d.setDate(currentMonday.getDate() + i);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const dayStr = String(d.getDate()).padStart(2, '0');
      weekDates.push(`${y}-${m}-${dayStr}`);
    }

    // 이번 주에 해당하는 데이터만 필터링하고 날짜순 정렬
    return schedule
      .filter((item) => weekDates.includes(item.date))
      .sort((a, b) => new Date(a.date) - new Date(b.date));
  }, [finalMenuData, mondayOfWeek]);
  const allProcessedMenuData = (Array.isArray(mealSchedule) ? mealSchedule : [])
    .map((item) => {
      if (!item.date) return null;
      const date = new Date(item.date);
      date.setHours(0, 0, 0, 0);
      
      // day_menu가 없거나, 빈 배열인 경우 체크
      const hasValidMenu = item.day_menu && 
        Array.isArray(item.day_menu) && 
        item.day_menu.length > 0;
      
      // 메뉴 아이템들을 문자열로 변환 (name만 추출)
      const menuItems = hasValidMenu 
        ? item.day_menu.map(menuItem => menuItem.name || menuItem).join("\n")
        : "식단 정보가 없습니다.";
      
      return {
        dateObj: date,
        date: `${date.getMonth() + 1}/${date.getDate()}`,
        label: item.day_name || "",
        items: menuItems,
        opacity: today.getTime() === date.getTime() ? 1 : 0.6,
        originalDayMenu: item.day_menu || []
      };
    })
    .filter(Boolean);

  const weekDates = [];
  for (let i = 0; i < 5; i++) {
    const nextDay = new Date(mondayOfWeek);
    nextDay.setDate(mondayOfWeek.getDate() + i);
    weekDates.push(nextDay);
  }

  // 요일/날짜 포맷: "8월 20일 수"
      const daysKOR = ["일", "월", "화", "수", "목", "금", "토"];
      const formatKoreanDateForHeader = (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        const wd = daysKOR[date.getDay()];
        return `${m}월 ${d}일 (${wd})`;
};

// "(...)" 괄호 보정
      const normalizeParenTag = (s) => {
        const t = (s || "").trim();
        if (!t) return null;
        return t.startsWith("(") ? t : `(${t})`;
};


  const processedMenuData = weekDates.map((weekDate) => {
    const menuItem = allProcessedMenuData.find(
      (item) => item.dateObj.getTime() === weekDate.getTime()
    );
    if (menuItem) {
      return menuItem;
    }
    return {
      dateObj: weekDate,
      date: `${weekDate.getMonth() + 1}/${weekDate.getDate()}`,
      label: "",
      items: "식단 정보가 없습니다.",
      opacity: today.getTime() === weekDate.getTime() ? 1 : 0.6,
    };
  });

  // 오늘 헤더 날짜
      const headerDate = formatKoreanDateForHeader(today);

// 오늘 메뉴 라벨 및 수요일 태그
      const todayMenuItem = processedMenuData.find(
        (m) => m.dateObj.getTime() === today.getTime()
);
      // API 데이터의 라벨을 먼저 확인
      const apiLabel = normalizeParenTag(todayMenuItem?.label);
      const headerTags = [
        apiLabel,                                              // 데이터에 있는 라벨
      ].filter(Boolean);

      const labelShownInHeader = !!normalizeParenTag(todayMenuItem?.label);


      // 오늘 데이터 (없으면 fallback)
      const todayMenu =
      processedMenuData.find(m => m.dateObj.getTime() === today.getTime()) ||
{
        dateObj: today,
        date: `${today.getMonth() + 1}/${today.getDate()}`,
        label: "",
        items: "식단 정보가 없습니다.",
        opacity: 1,
};

// 우측 패널 메타(시각/온도)
const [now, setNow] = React.useState(new Date());
React.useEffect(() => {
  if (!clockEnabled) return;
  const id = setInterval(() => setNow(new Date()), 60_000); // 1분마다 갱신
  return () => clearInterval(id);
}, [clockEnabled]);

const timeText = React.useMemo(() => {
  if (!clockEnabled) return null;
  // "오전 09:05" 형태
  return now.toLocaleTimeString("ko-KR", { hour: "2-digit", minute: "2-digit" });
}, [now, clockEnabled]);


// Timezone 문제를 피하기 위해 YYYY-MM-DD 형식으로 직접 생성
const todayString = today.getFullYear() + '-' +
                  String(today.getMonth() + 1).padStart(2, '0') + '-' +
                  String(today.getDate()).padStart(2, '0');


const todaysMeal = mealSchedule.find(day => day.date === todayString);

const lunchDisplay = 
  todaysMeal?.lunch_menu?.length > 0
    ? todaysMeal.lunch_menu.join('\n')
    : '식단 정보가 없습니다.';

const dinnerDisplay =
  todaysMeal?.dinner_menu?.length > 0
    ? todaysMeal.dinner_menu.join('\n')
    : '식단 정보가 없습니다.';

// 원산지 값 (없으면 빈 문자열)
const lunchOrigins = todaysMeal?.lunch_origins || "";
const dinnerOrigins = todaysMeal?.dinner_origins || "";




// Add helper function to get day of week
const getDayOfWeek = (dateString) => {
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  const date = new Date(dateString);
  return days[date.getDay()];
};

  return (
    <FullScreenContainer>
      <AspectRatioBox isHorizontal={isHorizontal}>
        <StyledContainer isDesktopScale={isDesktopScale} isHorizontal={isHorizontal}>
          <LogoSection>
            <LogoImage src={logo || gyeongwonLogo} alt="로고" />
          </LogoSection>
          {/* 로고 영역 */}
          <TopSection>
            {/* 타이틀 영역 */}
            {/* 타이틀 영역 - "주간 식단" 제거, 날짜 + 태그만 표시 */}
            <TitleSection>
              {/* <HeaderDate>{!showWeeklyView ? headerDate : "주간 식단표"}</HeaderDate> */}
              {/*{headerTags.map((t, i) => (
                <HeaderTag key={i}>{t}</HeaderTag>
              ))}*/}
            </TitleSection>
          </TopSection>

          {/* 메인 콘텐츠 영역 */}
          <ContentSection>
            {showWeeklyView ? (
              <WeeklyCardList isHorizontal={isHorizontal}>
                {mealSchedule.map((day) => {
                  const isToday = day.date === todayString;
                  return (
                    <DayColumn key={day.date} isToday={isToday} isHorizontal={isHorizontal}>
                      <DayHeader isToday={isToday} isHorizontal={isHorizontal}>
                        <DayDateText>
                          {day.date.split("-").slice(1).join("/")} (
                          {getDayOfWeek(day.date)})
                        </DayDateText>
                      </DayHeader>

                      <WeeklyMealSection>
                        <WeeklyCategoryTitle isHorizontal={isHorizontal}>중식</WeeklyCategoryTitle>
                        {day.lunch_menu && day.lunch_menu.length > 0 ? (
                          <WeeklyMenuList isHorizontal={isHorizontal}>
                            {day.lunch_menu.map((item, idx) => (
                              <WeeklyMenuItem key={idx} isHorizontal={isHorizontal}>{item}</WeeklyMenuItem>
                            ))}
                          </WeeklyMenuList>
                        ) : (
                          <WeeklyMenuText>정보 없음</WeeklyMenuText>
                        )}
                        <WeeklyOriginText isHorizontal={isHorizontal}>{day.lunch_origins}</WeeklyOriginText>
                      </WeeklyMealSection>

                      <WeeklyDivider isHorizontal={isHorizontal} />

                      <WeeklyMealSection>
                        <WeeklyCategoryTitle isHorizontal={isHorizontal}>석식</WeeklyCategoryTitle>
                        {day.dinner_menu && day.dinner_menu.length > 0 ? (
                          <WeeklyMenuList isHorizontal={isHorizontal}>
                            {day.dinner_menu.map((item, idx) => (
                              <WeeklyMenuItem key={idx} isHorizontal={isHorizontal}>{item}</WeeklyMenuItem>
                            ))}
                          </WeeklyMenuList>
                        ) : (
                          <WeeklyMenuText>정보 없음</WeeklyMenuText>
                        )}
                        <WeeklyOriginText isHorizontal={isHorizontal}>{day.dinner_origins}</WeeklyOriginText>
                      </WeeklyMealSection>
                    </DayColumn>
                  );
                })}
              </WeeklyCardList>
            ) : (
              <TwoCol isHorizontal={isHorizontal}>
                <MenuContainer isHorizontal={isHorizontal}>
                  <MenuDateSection>
                    <MenuDate isHorizontal={isHorizontal}>중식</MenuDate>
                  </MenuDateSection>
                  <Line687 />
                  <MenuItems isToday={true} isHorizontal={isHorizontal}>
                    {/* 세로 모드일 때는 문자열을 쪼개서 그리드 아이템으로 렌더링해야 함 */}
                    {/* 하지만 styled-component 내부에서 처리하기 어려우므로, 텍스트를 span으로 감싸는 방식으로 변경 필요 */}
                    {/* 간단하게는 CSS grid가 텍스트 노드에 직접 적용되지 않으므로, children을 맵핑하는 방식으로 변경 */}
                    {lunchDisplay.split('\n').map((item, idx) => (
                      <span key={idx} style={{ display: 'block' }}>{item}</span>
                    ))}
                  </MenuItems>
                  {lunchOrigins && <OriginText isHorizontal={isHorizontal}>{lunchOrigins}</OriginText>}
                </MenuContainer>
                <MenuContainer2 isHorizontal={isHorizontal}>
                  <MenuDateSection>
                    <MenuDate isHorizontal={isHorizontal}>석식</MenuDate>
                    <RightMeta>
                      {/* {timeText && <MetaChip>{timeText}</MetaChip>} */}
                    </RightMeta>
                  </MenuDateSection>
                  <Line687 />
                  <MenuItems2 isToday={true} isHorizontal={isHorizontal}>
                    {dinnerDisplay.split('\n').map((item, idx) => (
                      <span key={idx} style={{ display: 'block' }}>{item}</span>
                    ))}
                  </MenuItems2>
                  {dinnerOrigins && (
                    <OriginText isHorizontal={isHorizontal}>{dinnerOrigins}</OriginText>
                  )}
                </MenuContainer2>
              </TwoCol>
            )}
          </ContentSection>
        </StyledContainer>
      </AspectRatioBox>
    </FullScreenContainer>
  );
};

export default MoleculeMenuBoardInfoBoard;

// 스타일 컴포넌트들
const FullScreenContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const AspectRatioBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

const TopSection = styled.div`
  width: 100%;
  height: auto;
  padding: 0;
  box-sizing: border-box;
  align-items: center;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between; /* date/left and logo/right */
  gap: 12px;
  z-index: 1;
`;

const LogoSection = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.2;
  z-index: 0;
  pointer-events: none;
`;

const LogoImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const TitleSection = styled.div`
  position: relative;
  left: 0;
  top: 0;
  display: flex;
  align-items: flex-start; /* left align date */
  gap: 12px;
  flex-direction: column;
`;

const ContentSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow: hidden;
  position: relative;
  z-index: 1;
`;

const MenuContainer = styled.div`
  padding: 20px;
  height: auto;
  width: 100%;
  background: transparent;
  box-shadow: none;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  /* 가로 모드일 때 너비 50% */
  ${({ isHorizontal }) => isHorizontal ? `
    width: 50%;
  ` : `
    flex: 1; /* 1:1 비율로 공간 분할 */
    justify-content: flex-start; 
  `}
`;

const MenuContainer2 = styled.div`
  padding: 20px; /* 패딩 증가 */
  height: auto;
  width: 100%;
  background: transparent;
  box-shadow: none;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  /* 가로 모드일 때 너비 50% */
  ${({ isHorizontal }) => isHorizontal ? `
    width: 50%;
  ` : `
    margin-top: auto; /* 중식 아래로 밀어내서 중간부터 배치 */
    flex: 1; /* 남은 공간 차지 */
    justify-content: flex-start; /* 상단 정렬 */
  `}
`;

const RightMeta = styled.div`
  position: absolute; /* 절대 위치로 변경하여 중앙 정렬 방해하지 않도록 함 */
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: calc(2.3 * var(--font-scaler));
`;

const MetaChip = styled.span`
  // padding: 8px 14px;
  border-radius: 8px;
  background: none;
  color: #323232;
  // font-size: 42px;             /* time larger */
  font-size: calc(1.5 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1;
  // @media (max-width: 900px) {
  //   font-size: 28px; /* reduce on smaller screens */
  //   padding: 6px 10px;
  // }
`;

const MenuDateSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center; /* 타이틀 중앙 정렬 */
  width: 100%; /* 너비를 꽉 채워서 중앙 정렬이 제대로 동작하도록 함 */
  position: relative; /* RightMeta를 절대 위치로 보낼 경우 필요할 수 있음 */
  margin-bottom: 8px; /* 하단 여백 추가 */
`;

const MenuDate = styled.span`
  color: #323232;
  // font-size: 48px; /* increased menu date */
  font-size: calc(3 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 700 : 600)};
  line-height: 1.2;
  text-align: start;

  ${({ isHorizontal }) => !isHorizontal && `
    font-size: calc(4 * var(--font-scaler)); /* 세로 모드에서 크게 */
  `}
`;

const MenuLabel = styled.span`
  color: #323232;
  font-size: 36px; /* increased menu label */
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 800 : 700)};
  line-height: 1.2;
`;

const MenuItems = styled.div`
  color: #323232;
  // font-size: 30px; /* increased overall menu font */
   font-size: 40px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 600 : 400)}; /* 폰트 굵기 증가 */
  white-space: pre-line;
  text-align: center; /* 중앙 정렬로 변경 */
  line-height: 1.6;

  ${({ isHorizontal }) => !isHorizontal && `
    // font-size: 40px; /* 세로 모드에서 훨씬 크게 */
     font-size: calc(2.4 * var(--font-scaler));
    line-height: 1.4;
    font-weight: 700;
    
    /* 2열 그리드 배치 */
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 32px; /* 간격 증가 (8px 16px -> 16px 32px) */
    justify-content: center;
    align-items: center;
    
    white-space: normal;
  `}
`;

const MenuItems2 = styled.div`
  color: #323232;
  // font-size: 30px; /* increased */
  font-size: 40px;
  font-family: Pretendard;
  font-weight: ${(props) => (props.isToday ? 600 : 400)};
  white-space: pre-line;
  text-align: center; /* 중앙 정렬로 변경 */
  line-height: 1.6;

  ${({ isHorizontal }) => !isHorizontal && `
    // font-size: 40px; /* 세로 모드에서 훨씬 크게 */
     font-size: calc(2.4 * var(--font-scaler));
    line-height: 1.4;
    font-weight: 700;

    /* 2열 그리드 배치 */
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 32px; /* 간격 증가 */
    justify-content: center;
    align-items: center;
    white-space: nowrap;
  `}
`;

const OriginText = styled.div`
  color: rgba(50, 50, 50, 0.7); /* 색상 연하게 변경하여 위계 구분 */
  font-size: 24px; /* 크기 줄임 */
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.4;
  margin-top: 16px; /* 여백 증가 */
  white-space: pre-line;
  text-align: center; /* 중앙 정렬 */

  ${({ isHorizontal }) => !isHorizontal && `
    font-size: 28px; /* 세로 모드에서도 너무 크지 않게 */
  `}
`;

const NoticeSection = styled.div`
  padding: 12px 16px;
  width: 100%;
  background: transparent;
  box-shadow: none;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-top: auto;
  box-sizing: border-box;
`;

const StyledLine = styled.div`
  width: 100%;
  // height: ${(props) => (props.isToday ? "12" : "8")}px;
    height: 3px;
  background: #323232;
  margin-bottom: 0px;
`;

const HeaderDate = styled.span`
  color: #323232;
  font-size: calc(2.3 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.1;
`;

const HeaderTag = styled.span`
  color: #323232;
  font-size: 44px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.2;
`;

const TwoCol = styled.div`
  width: 100%;
  height: 100%; /* 전체 높이 사용 */
  display: flex;
  gap: 12px;
  justify-content: space-between;
  flex-direction: column; /* 기본: 세로 배치 */

  /* 세로 모드에서 간격 줄임 */
  ${({ isHorizontal }) => !isHorizontal && `
    gap: 0;
  `}

  /* 가로 모드일 때 가로 배치 */
  ${({ isHorizontal }) => isHorizontal && `
    flex-direction: row;
    gap: 24px;
    height: auto; /* 가로 모드에서는 높이 자동 */
  `}
`;

const DayDate = styled.span`
  font-weight: bold;
  font-size: 14px;
`;

const DayOfWeek = styled.span`
  font-size: 12px;
  color: #666;
`;

const MenuItem = styled.div`
  margin: 4px 0;
  font-size: 14px;
`;

// Add styles
const WeeklyCardList = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  margin-top: 12px;

  /* 세로 모드 스타일 (미디어 쿼리) */
  ${({ isHorizontal }) => !isHorizontal && `
    flex-direction: column;
  `}
`;

const DayColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) =>
    props.isToday ? "rgba(255, 255, 255, 0.6)" : "rgba(255, 255, 255, 0.3)"};
  border-radius: 12px;
  padding: 12px 8px;
  gap: 8px;
  border: ${(props) =>
    props.isToday ? "2px solid #323232" : "1px solid rgba(50,50,50,0.1)"};
  box-shadow: ${(props) =>
    props.isToday ? "0 4px 12px rgba(0,0,0,0.1)" : "none"};
  align-items: stretch;

  /* 세로 모드 스타일 */
  ${({ isHorizontal }) => !isHorizontal && `
    flex-direction: row;
    align-items: center;
  `}
`;

const DayHeader = styled.div`
  text-align: center;
  padding-bottom: 8px;
  border-bottom: 2px solid #323232;
  margin-bottom: 4px;

  /* 세로 모드 스타일 */
  ${({ isHorizontal }) => !isHorizontal && `
    width: 15%;
    min-width: 80px;
    border-bottom: none;
    border-right: 2px solid #323232;
    padding-bottom: 0;
    padding-right: 8px;
    margin-bottom: 0;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `}
`;

const DayDateText = styled.span`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 24px;
  color: #323232;
  white-space: pre-wrap; /* 세로 모드에서 줄바꿈 허용 */
`;

const WeeklyMealSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
  height: 100%;
  justify-content: center;
`;

const WeeklyCategoryTitle = styled.div`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 22px;
  color: #323232;
  margin-bottom: 4px;
  text-align: center;
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
  padding: 2px 0;

  ${({ isHorizontal }) => !isHorizontal && `
    font-size: 25px; /* 세로 모드에서 폰트 크기 증가 */
    padding: 4px 0;
  `}
`;

const WeeklyMenuText = styled.div`
  font-family: Pretendard;
  font-size: 22px;
  color: #323232;
  white-space: pre-line;
  line-height: 1.4;
  text-align: center;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WeeklyMenuList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px 8px;
  flex: 1;
  overflow-y: auto;
  align-content: start;
  padding: 4px;

  ${({ isHorizontal }) => !isHorizontal && `
    grid-template-columns: 1fr 1fr; /* 세로 모드에서 2열로 변경 */
    align-content: center top; /* 중앙 정렬 */
  `}
`;

const WeeklyMenuItem = styled.div`
  font-family: Pretendard;
  font-size: 19px;
  color: #323232;
  text-align: center;
  word-break: keep-all;
  line-height: 1.3;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;

  ${({ isHorizontal }) => !isHorizontal && `
    font-size: 22px; /* 세로 모드에서 폰트 크기 증가 */
    line-height: 1.4;
  `}
`;

const WeeklyOriginText = styled.div`
  font-family: Pretendard;
  font-size: 16px;
  color: #666;
  margin-top: auto;
  text-align: center;

  ${({ isHorizontal }) => !isHorizontal && `
    font-size: 18px; /* 세로 모드에서 폰트 크기 증가 */
  `}
`;

const WeeklyDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #ccc;
  margin: 4px 0;
  flex-shrink: 0;

  /* 세로 모드 스타일 */
  ${({ isHorizontal }) => !isHorizontal && `
    width: 1px;
    height: 100%;
    margin: 0 4px;
  `}
`;
